import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorBarService {

  public errorMessage: WritableSignal<string | null> = signal<string | null>(null);

  constructor() {
  }

  public setError(e: string): void {
    this.errorMessage.set(e);
  }
}
